<template>
    <div >
<!--      11111-->
<!--      <el-link type="primary" @click="$refs.viewFileListRef.show(fileId)">查看</el-link>-->
      <ViewFileList ref="viewFileListRef" />
    </div>

</template>

<script>
import ViewFileList from "../../../Common/ViewFileList";
export default {
  name: "ViewPic",
  components: {ViewFileList},
  data(){
    return {
      isShow:false,
      fileId:0,
    }
  },
  mounted() {

  },
  methods:{
    initConfig(){

    },
    /**
     * 显示列表
     */
    show({file_id = 0,},callback_fun){
      const that = this;
      that.initConfig();
      that.fileId = file_id;
      console.info(that.fileId)
      that.isShow = true;
      if(typeof callback_fun==="function"){
        that.callback_fun=callback_fun;
      }
      that.$refs.viewFileListRef.show(that.fileId)
    },

  }
}
</script>

<style lang="scss" scoped>
.personnel{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .personnel-left{
    width: 300px;
    height: 50vh;
    //overflow-y: scroll;

    .user_role_body{
      height: 50vh;
      overflow-y: scroll;
      .user_role_body_item{
        color: #6f7175;
        width: 100%;
        cursor: pointer;
        padding: 2px 0 2px 5px;
        margin: 2px 0;
        &:hover{
          background-color: #e8e8e8;
        }
        &:active{
          background-color: #b2c7d0;
        }
        &.active{
          background-color: #b2c7d0;
        }
      }
    }
    .history_user_body{
      height: 50vh;
      overflow-y: scroll;
      .history_user_body_item{
        color: #6f7175;
        width: 100%;
        cursor: pointer;
        padding: 2px 0 2px 5px;
        margin: 2px 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &:hover{
          background-color: #e8e8e8;
        }
        &:active{
          background-color: #b2c7d0;
        }
        &.active{
          background-color: #b2c7d0;
        }
      }
    }
  }
  .personnel-right{
    width: 600px;
    margin-left: 5px;
    height: 100%;
  }
  .personnel-right-select{
    width: 150px;
    .personnel-right-select-view{
      height: 50vh;
      overflow-y: scroll;
    }
  }
}
.personnel-footer{
  margin-top: 10px;
  width: 100%;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/plug/ViewPic.vue